import React from "react";
import {View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";
import Config from "../../Config";

const ExamImage = (props) => {


    const sendResult = (answer)=>{

        //save result
        props.setResults((prevState)=>[
            {id : props.question.id , answer :answer} ,
            ...prevState
        ]);

        props.setNumber((prevState)=>(prevState + 1))

    }


    return (
        <View style={styles.container}>
            <Image style={styles.image}    source={{uri : `${Config.dl}/${props.question.url}`}}    />
            <Text style={styles.text}>
                {props.question.ask}
            </Text>


            {props.question.correct ?
                <>
                    {props.question.correct == 1 ?
                        <TouchableOpacity  style={styles.buttons} onPress={() => sendResult(1)}>
                            <Text style={styles.label} >
                                {props.question.s1}
                            </Text>
                        </TouchableOpacity>
                        :
                        <TouchableOpacity  style={styles.button} onPress={() => sendResult(1)}>
                            <Text style={styles.label} >
                                {props.question.s1}
                            </Text>
                        </TouchableOpacity>
                    }
                    {props.question.correct == 2 ?
                        <TouchableOpacity  style={styles.buttons} onPress={() => sendResult(2)} >
                            <Text style={styles.label} >
                                {props.question.s2}
                            </Text>
                        </TouchableOpacity>
                        :
                        <TouchableOpacity  style={styles.button} onPress={() => sendResult(2)} >
                            <Text style={styles.label} >
                                {props.question.s2}
                            </Text>
                        </TouchableOpacity>

                    }
                    {props.question.correct == 3 ?
                        <TouchableOpacity  style={styles.buttons} onPress={() => sendResult(3)} >
                            <Text style={styles.label} >
                                {props.question.s3}
                            </Text>
                        </TouchableOpacity>
                        :
                        <TouchableOpacity  style={styles.button} onPress={() => sendResult(3)} >
                            <Text style={styles.label} >
                                {props.question.s3}
                            </Text>
                        </TouchableOpacity>
                    }
                    {props.question.correct == 4 ?
                        <TouchableOpacity  style={styles.buttons} onPress={() => sendResult(4)} >
                            <Text style={styles.label} >
                                {props.question.s4}
                            </Text>
                        </TouchableOpacity>
                        :
                        <TouchableOpacity  style={styles.button} onPress={() => sendResult(4)} >
                            <Text style={styles.label} >
                                {props.question.s4}
                            </Text>
                        </TouchableOpacity>
                    }

                </>
                :
                <>
                    <TouchableOpacity  style={styles.button} onPress={() => sendResult(1)}>
                        <Text style={styles.label} >
                            {props.question.s1}
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity  style={styles.button} onPress={() => sendResult(2)} >
                        <Text style={styles.label} >
                            {props.question.s2}
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity  style={styles.button} onPress={() => sendResult(3)} >
                        <Text style={styles.label} >
                            {props.question.s3}
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity  style={styles.button} onPress={() => sendResult(4)} >
                        <Text style={styles.label} >
                            {props.question.s4}
                        </Text>
                    </TouchableOpacity>
                </>
            }







        </View>
    )
};

const styles = StyleSheet.create({

    button : {
      marginVertical : RFValue(4),
        backgroundColor : 'white',
        borderRadius : RFValue(20),
        borderWidth : 1,
        borderColor : '#E7E9F2',
        padding : RFValue(20),
        justifyContent : 'center',
        alignItems: 'center',
    },
    buttons : {
        marginVertical : RFValue(4),
        backgroundColor : '#E9FFE0',
        borderRadius : RFValue(20),
        borderWidth : 1,
        borderColor : '#33B300',
        padding : RFValue(20),
        justifyContent : 'center',
        alignItems: 'center',
    },

    label : {
        fontSize: RFValue(15),
        fontFamily: 'ykb',
        color: Config.maincolor,
        textAlign: 'center',
    },

    text : {
       fontSize: RFValue(14),
       fontFamily: 'ykb',
        color: Config.maincolor,
        marginBottom : RFValue(20),

    },
    container: {
        flex: 1,


    },
    image: {
        marginBottom : RFValue(20),
        width: '100%',
        height : RFValue(180),
        borderRadius: RFValue(15),
    },
});
export default ExamImage;